import { useEffect, useCallback } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchAspects = () => {
  const { apiGet } = useApi();
  const useApiState = createApiHook([]);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const fetchData = useCallback(async () => {
    startLoading();
    const response = await apiGet("/aspects", "Error al obtener los aspectos");
    setResponse(response);
    return response?.data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, error, loading, refetch: fetchData };
};

export default useFetchAspects;
